import React, {FC, useState} from 'react';
import {
	DisconnectButton,
	useLocalParticipant,
	useRoomContext,
	useStartAudio,
} from '@livekit/components-react';
import classNames from 'classnames';
import Button from 'components/Button';

import HangUp from './svgs/hangup.inline.svg';
import {Microphone} from './Microphone';

import * as styles from './styles.module.scss';

export const Controls: FC = () => {
	const room = useRoomContext();
	const {microphoneTrack: track} = useLocalParticipant();
	const audio = useStartAudio({room, props: {}});
	const [error, setError] = useState<boolean>(false);

	return (
		<>
			<div className={classNames({
				[styles.controls]: true,
				[styles.muted]: track?.isMuted || !track?.isEnabled,
			})}>
				{audio.canPlayAudio ? (
					<>
						<Microphone onDeviceError={() => setError(true)} />
						<DisconnectButton>
							<HangUp />
						</DisconnectButton>
					</>
				) : (
					<div>
						<Button
							{...audio.mergedProps}
							className=''
							style={{}}
							variant='light'
						>
							Start audio
						</Button>
					</div>
				)}
			</div>
			{!track?.isEnabled && error && (
				<div className={styles.deviceError}>
					We couldn't access your microphone.
					Please check your browser settings.
				</div>
			)}
		</>
	);
};
